export function loadJson(fileurl) {
  const result = loadJSON(fileurl);
  return result;
}

// Load JSON text from server hosted file and return JSON parsed object
function loadJSON(filePath) {
  var json = loadTextFileAjaxSync(filePath, "application/json");
  return JSON.parse(json);
}   

// Load text with Ajax synchronously: takes path to file and optional MIME type
function loadTextFileAjaxSync(filePath, mimeType)
{
  var xmlhttp=new XMLHttpRequest();
  xmlhttp.open("GET",filePath,false);
  if (mimeType != null) {
    if (xmlhttp.overrideMimeType) {
      xmlhttp.overrideMimeType(mimeType);
    }
  }
  xmlhttp.send();
  if (xmlhttp.status===200 && xmlhttp.readyState === 4 )
  {
    return xmlhttp.responseText;
  }
  else {
    console.log("Error in loading file...");
    console.log(xmlhttp);
    return null;
  }
}


// WEBPACK FOOTER //
// ./src/utils/loadjson.js